"use client";

import { useCallback } from "react";
import { useAuth } from "@/core/components/auth/store/auth";
import {
  screenFromPathname,
  trackBrunaOpened,
} from "../services/bruna-opened-service";

/**
 * Retorna um disparador do evento `bruna_aberta` para a tela (pathname) informada.
 * Só envia com o usuário já hidratado no store (o backend rejeita `user_id` vazio) e devolve
 * se enviou, para quem chama poder tentar de novo quando o `userId` chegar.
 */
export function useTrackBrunaOpened(): (pathname: string) => boolean {
  const userId = useAuth((state) => state.userInfo?.user?.id);
  return useCallback(
    (pathname: string) => {
      // `0` é um id válido: só ausente impede o envio.
      if (userId == null) return false;
      void trackBrunaOpened(userId, screenFromPathname(pathname));
      return true;
    },
    [userId],
  );
}
